export const geometryKeysProps = [
  {
    id: 'a1',
    label: '\\^{}',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\^{}',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a2',
    label: '\\_{}',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\_{}',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a3',
    label: '\\frac{}{}',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\frac{}{}',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a4',
    label: '\\mfrac{}{}{}',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\mfrac{}{}{}',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a5',
    label: '\\left({}\\right)',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\left({}\\right)',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a6',
    label: '\\sqrt{ }',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\sqrt{ }',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a7',
    label: '\\^{}\\sqrt{ }',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\^{}\\sqrt{ }',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a8',
    label: '\\^{\\circ}',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\^{\\circ}',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a9',
    label: '\\left\\{\\right\\}',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\left\\{\\right\\}',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a10',
    label: '\\left(\\left(\\right),\\left(\\right)\\right)',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\left(\\left(\\right),\\left(\\right)\\right)',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a11',
    label: '\\left(\\frac{ }{ }\\right)',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\left(\\frac{ }{ }\\right)',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: 'a12',
    label: '\\ne',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\ne',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: '-',
    label: '-',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '-',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: '×',
    label: '×',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '×',
      method: 'write',
    },
    group: 'geometry',
  },
  {
    id: '|',
    label: '|',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '|',
      method: 'write',
    },
    group: 'geometry',
  },
]
